const icons = {
  app: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      {...props}
    >
      <rect
        x="0.162109"
        y="0.164062"
        width="21"
        height="21"
        fill="white"
        fillOpacity="0.01"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="3"
        y="0"
        width="16"
        height="22"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.41152 0.164062H15.9115C17.0713 0.164062 18.0115 1.10426 18.0115 2.26406V19.0641C18.0115 20.2239 17.0713 21.1641 15.9115 21.1641H5.41152C4.25173 21.1641 3.31152 20.2239 3.31152 19.0641V2.26406C3.31152 1.10426 4.25173 0.164062 5.41152 0.164062ZM5.41135 2.25963V19.0596H15.9113V2.25963H5.41135ZM11.7117 16.9641C11.7117 17.544 11.2416 18.0141 10.6617 18.0141C10.0818 18.0141 9.61173 17.544 9.61173 16.9641C9.61173 16.3842 10.0818 15.9141 10.6617 15.9141C11.2416 15.9141 11.7117 16.3842 11.7117 16.9641Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <rect
          x="0.162109"
          y="0.164062"
          width="21"
          height="21"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  apple: (props) => (
    <svg
      width="28"
      height="34"
      viewBox="0 0 28 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.4094 17.996C23.3934 15.2641 24.6312 13.2051 27.1308 11.687C25.7328 9.6841 23.6177 8.58253 20.8298 8.37022C18.19 8.16192 15.3019 9.90842 14.2443 9.90842C13.1268 9.90842 10.5711 8.44233 8.56023 8.44233C4.4103 8.50642 0 11.7511 0 18.3525C0 20.3033 0.356509 22.3181 1.06953 24.3931C2.02289 27.125 5.4598 33.8186 9.04492 33.7104C10.9196 33.6664 12.2455 32.3805 14.685 32.3805C17.0524 32.3805 18.2781 33.7104 20.3691 33.7104C23.9863 33.6583 27.0947 27.5737 28 24.8337C23.1491 22.5465 23.4094 18.1362 23.4094 17.996ZM19.1994 5.77852C21.2303 3.36708 21.0461 1.17194 20.986 0.382812C19.1914 0.486961 17.1165 1.60456 15.9348 2.97852C14.6329 4.45263 13.8678 6.27523 14.032 8.33017C15.9708 8.47838 17.7413 7.48095 19.1994 5.77852Z"
        fill="#FDEFFF"
      />
    </svg>
  ),
  "arrow-down": (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      {...props}
    >
      <path d="M0.910011 0.272244C1.21691 0.111124 1.59344 0.173114 1.83249 0.424114L5 3.75L8.16751 0.424113C8.40656 0.173114 8.78309 0.111124 9.08999 0.272244C9.54617 0.51174 9.6465 1.12117 9.29117 1.49427L5.36721 5.61443C5.16737 5.82427 4.83263 5.82427 4.63279 5.61443L0.708827 1.49427C0.353496 1.12117 0.453828 0.51174 0.910011 0.272244Z" />
    </svg>
  ),
  "arrow-left": (props) => (
    <svg
      width="8"
      height="11"
      viewBox="0 0 15 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5343 2.01953L2.12109 12.8492L12.5343 21.3583"
        stroke="currentColor"
        stroke-width="3.63636"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  "arrow-right": (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      {...props}
    >
      <path
        d="M0.341886 12.6838C0.137715 12.2754 0.217747 11.7823 0.540569 11.4594L5 7L0.540568 2.54057C0.217745 2.21775 0.137714 1.72457 0.341886 1.31623C0.665651 0.668696 1.52865 0.528651 2.04057 1.04057L7.52939 6.52939C7.7893 6.7893 7.7893 7.2107 7.52939 7.47061L2.04057 12.9594C1.52865 13.4713 0.665652 13.3313 0.341886 12.6838Z"
        fill="currentColor"
      />
    </svg>
  ),
  "arrow-topright": (props) => (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.50093 1.59176L1.67329 9.59886M9.50093 1.59176L2.22341 1.68959M9.50093 1.59176L9.56815 8.86971"
        stroke="currentColor"
        stroke-width="2.05535"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  "bullet-ring": (props) => (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21ZM10.5 17.7692C14.5147 17.7692 17.7692 14.5147 17.7692 10.5C17.7692 6.48531 14.5147 3.23077 10.5 3.23077C6.48531 3.23077 3.23077 6.48531 3.23077 10.5C3.23077 14.5147 6.48531 17.7692 10.5 17.7692Z"
        fill="currentColor"
      />
    </svg>
  ),
  call: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.77189 2.43881L6.84789 2.09481C7.85789 1.77281 8.93489 2.29381 9.36789 3.31181L10.2269 5.33981C10.6009 6.22281 10.3939 7.26181 9.71289 7.90781L7.81889 9.70581C7.93489 10.7818 8.29689 11.8408 8.90289 12.8828C9.47867 13.891 10.2509 14.7734 11.1739 15.4778L13.4489 14.7178C14.3119 14.4308 15.2509 14.7618 15.7789 15.5388L17.0119 17.3488C17.6269 18.2528 17.5169 19.4988 16.7539 20.2648L15.9359 21.0858C15.1219 21.9028 13.9589 22.1998 12.8839 21.8638C10.3449 21.0718 8.01089 18.7208 5.88089 14.8108C3.74789 10.8948 2.99489 7.57081 3.62289 4.84281C3.88689 3.69481 4.70389 2.77981 5.77189 2.43881Z"
        fill="currentColor"
      />
    </svg>
  ),
  chat: (props) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M14.1031 36.625L5.75 43.1875V8.5C5.75 8.00272 5.94754 7.52581 6.29917 7.17417C6.65081 6.82254 7.12772 6.625 7.625 6.625H41.375C41.8723 6.625 42.3492 6.82254 42.7008 7.17417C43.0525 7.52581 43.25 8.00272 43.25 8.5V34.75C43.25 35.2473 43.0525 35.7242 42.7008 36.0758C42.3492 36.4275 41.8723 36.625 41.375 36.625H14.1031ZM12.8056 32.875H39.5V10.375H9.5V35.4719L12.8056 32.875ZM22.625 19.75H26.375V23.5H22.625V19.75ZM15.125 19.75H18.875V23.5H15.125V19.75ZM30.125 19.75H33.875V23.5H30.125V19.75Z" />
      </g>
    </svg>
  ),
  "checked-circle": (props) => (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <ellipse cx="13.0215" cy="13" rx="12.5" ry="13" />
      <path
        d="M8.85547 13.7423L11.7466 16.7137L15.3606 12.9994L18.9745 9.28516"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "chevron-right": (props) => (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 1L5.5 6L1 11"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  close: (props) => (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.97754 10.7773L11.5235 1.2314"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.97754 1.07031L11.5235 10.6163"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.97754 10.7773L11.5235 1.2314"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  crown: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0)">
        <path
          d="M1.99902 19H21.999V21H1.99902V19ZM1.99902 5L6.99902 8.5L11.999 2L16.999 8.5L21.999 5V17H1.99902V5ZM3.99902 8.841V15H19.999V8.841L16.579 11.235L11.999 5.28L7.41902 11.235L3.99902 8.84V8.841Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  facebook: (props) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M10.1426 10.3549H11.9283L12.6426 7.49777H10.1426V6.0692C10.1426 5.33348 10.1426 4.64062 11.5711 4.64062H12.6426V2.24063C12.4097 2.20991 11.5304 2.14062 10.6019 2.14062C8.66258 2.14062 7.28544 3.3242 7.28544 5.49777V7.49777H5.14258V10.3549H7.28544V16.4263H10.1426V10.3549Z"
          fill="#4824C1"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="17.1429"
            height="17.1429"
            fill="white"
            transform="translate(0.142578 0.714844)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  female: (props) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M22.6252 30.8763C19.0925 30.3973 15.8736 28.5948 13.6193 25.8331C11.3649 23.0714 10.2435 19.5567 10.4816 15.9997C10.7198 12.4427 12.2999 9.10891 14.9023 6.67244C17.5047 4.23597 20.9352 2.87866 24.5002 2.87501C28.0695 2.87157 31.5065 4.22552 34.1145 6.66237C36.7225 9.09923 38.3063 12.4366 38.5448 15.998C38.7833 19.5593 37.6586 23.0781 35.3988 25.8409C33.1389 28.6037 29.9131 30.4038 26.3752 30.8763V34.75H35.7502V38.5H26.3752V46H22.6252V38.5H13.2502V34.75H22.6252V30.8763ZM24.5002 27.25C27.2352 27.25 29.8582 26.1635 31.7922 24.2295C33.7262 22.2956 34.8127 19.6726 34.8127 16.9375C34.8127 14.2025 33.7262 11.5794 31.7922 9.64547C29.8582 7.7115 27.2352 6.62501 24.5002 6.62501C21.7651 6.62501 19.1421 7.7115 17.2081 9.64547C15.2742 11.5794 14.1877 14.2025 14.1877 16.9375C14.1877 19.6726 15.2742 22.2956 17.2081 24.2295C19.1421 26.1635 21.7651 27.25 24.5002 27.25Z" />
      </g>
    </svg>
  ),
  "grad-cap": (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M3.33 8L10 12L20 6L10 0L0 6H10V8H3.33ZM0 8V16L2 13.78V9.2L0 8ZM10 20L5 17L3 15.8V9.8L10 14L17 9.8V15.8L10 20Z"
        fill="#4824C1"
      />
    </svg>
  ),
  hamburger: (props) => (
    <svg
      width="16"
      height="11"
      viewBox="0 0 16 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 5.5H14.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1H14.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 10H14.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  heart: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M3.25028 4.54521C4.39867 3.39662 5.93894 2.72481 7.56204 2.66458C9.18513 2.60436 10.771 3.16018 12.0013 4.22052C13.2306 3.16195 14.8143 2.60675 16.4354 2.66608C18.0566 2.72541 19.5955 3.39488 20.7441 4.54047C21.8927 5.68606 22.5662 7.22321 22.6298 8.8442C22.6933 10.4652 22.1423 12.0504 21.0869 13.2824L13.4001 20.994C13.0469 21.3473 12.5733 21.554 12.0741 21.5727C11.5749 21.5915 11.0871 21.4208 10.7085 21.095L10.5996 20.995L2.9137 13.2824C1.85891 12.0514 1.30761 10.4677 1.37001 8.84785C1.43241 7.22799 2.10392 5.69138 3.25028 4.54521ZM4.65005 5.94498C3.84052 6.75474 3.37387 7.84511 3.34696 8.9898C3.32005 10.1345 3.73494 11.2456 4.50552 12.0925L4.65005 12.2449L12.0003 19.5952L17.2499 14.3446L13.7505 10.8452L12.7012 11.8945C12.4255 12.1704 12.0981 12.3892 11.7378 12.5386C11.3775 12.6879 10.9913 12.7648 10.6013 12.7649C9.81354 12.7651 9.05802 12.4523 8.5009 11.8955C7.94377 11.3386 7.63068 10.5833 7.63049 9.79554C7.63031 9.00783 7.94304 8.25232 8.49991 7.69519L10.5808 5.61336C9.75264 4.95245 8.71612 4.60826 7.65716 4.64255C6.5982 4.67684 5.58612 5.08736 4.8025 5.80045L4.65005 5.94498ZM13.0506 8.74452C13.2363 8.55894 13.488 8.45468 13.7505 8.45468C14.013 8.45468 14.2648 8.55894 14.4504 8.74452L18.6497 12.9438L19.3506 12.2449C20.1737 11.4224 20.6423 10.3105 20.6562 9.14699C20.67 7.98346 20.2281 6.86069 19.4249 6.01879C18.6216 5.17688 17.5209 4.68269 16.358 4.64189C15.1951 4.60108 14.0624 5.01692 13.2021 5.80045L13.0506 5.94498L9.90067 9.09496C9.72908 9.26643 9.62643 9.49494 9.6122 9.73709C9.59796 9.97925 9.67314 10.2182 9.82345 10.4086L9.90067 10.4947C10.0721 10.6663 10.3006 10.769 10.5428 10.7832C10.785 10.7974 11.0239 10.7223 11.2143 10.5719L11.3004 10.4947L13.0506 8.74452Z"
        fill="white"
      />
    </svg>
  ),
  heartbeat: (props) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M32.9375 6.625C38.6338 6.625 43.25 11.3125 43.25 17.875C43.25 31 29.1875 38.5 24.5 41.3125C20.7931 39.0887 11.2194 33.9306 7.37937 25.3769L3.875 25.375V21.625H6.14375C5.88875 20.4325 5.75 19.1838 5.75 17.875C5.75 11.3125 10.4375 6.625 16.0625 6.625C19.55 6.625 22.625 8.5 24.5 10.375C26.375 8.5 29.45 6.625 32.9375 6.625ZM32.9375 10.375C30.92 10.375 28.7375 11.4437 27.1512 13.0262L24.5 15.6775L21.8488 13.0262C20.2625 11.4437 18.08 10.375 16.0625 10.375C12.425 10.375 9.5 13.48 9.5 17.875C9.5 19.1594 9.66875 20.41 10.0006 21.625H14.0638L17.9375 15.1675L23.5625 24.5425L25.3137 21.625H33.875V25.375H27.4363L23.5625 31.8325L17.9375 22.4575L16.1862 25.375H11.5775C13.0587 27.9513 15.2994 30.3775 18.2094 32.6931C19.6063 33.8031 21.0969 34.84 22.7488 35.8806C23.3094 36.235 23.8644 36.5744 24.5 36.9531C25.1356 36.5744 25.6906 36.235 26.2512 35.8825C27.9031 34.84 29.3937 33.8031 30.7887 32.6931C36.3781 28.2494 39.5 23.3931 39.5 17.875C39.5 13.45 36.6181 10.375 32.9375 10.375Z" />
    </svg>
  ),
  iddera1: (props) => (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.5544 17.4374C18.6034 20.6229 14.596 20.4338 13.111 20.3389C12.6856 18.5593 12.4033 14.8901 15.3543 11.7041C18.3053 8.51802 22.6216 8.61668 23.7996 8.80261C24.0844 10.0042 24.5054 14.2514 21.5544 17.4374Z"
        fill="url(#paint0_linear)"
      />
      <g style={{ mixBlendMode: "multiply" }}>
        <path
          d="M13.1104 7.0885C17.7635 11.7114 17.4628 17.8103 17.0254 20.0477C14.4302 20.7434 8.76683 20.751 4.11248 16.1268C-0.541866 11.5027 -0.157643 5.00094 0.189233 3.2378C2.0173 2.86974 8.4573 2.46563 13.1104 7.0885Z"
          fill="url(#paint1_linear)"
        />
      </g>
      <path
        d="M18.9722 6.5985C20.796 6.5985 22.2745 5.12138 22.2745 3.29925C22.2745 1.47712 20.796 0 18.9722 0C17.1484 0 15.6699 1.47712 15.6699 3.29925C15.6699 5.12138 17.1484 6.5985 18.9722 6.5985Z"
        fill="url(#paint2_linear)"
      />
      <g style={{ mixBlendMode: "multiply" }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9301 11.1367C17.5873 14.7808 17.3422 18.4274 17.0254 20.048C16.7976 20.1091 16.5461 20.1648 16.2738 20.2126C14.9322 20.4374 13.7746 20.3767 13.1149 20.3345C12.6895 18.555 12.4072 14.8858 15.3582 11.6997C15.5438 11.4993 15.7348 11.3119 15.9301 11.1367Z"
          fill="url(#paint3_linear)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="18.4238"
          y1="8.72656"
          x2="18.4238"
          y2="20.3794"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF33C6" />
          <stop offset="1" stopColor="#7433FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="8.62753"
          y1="3.03125"
          x2="8.62753"
          y2="20.3837"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF33C6" />
          <stop offset="1" stopColor="#7433FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="18.9722"
          y1="0"
          x2="18.9722"
          y2="6.5985"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF33C6" />
          <stop offset="1" stopColor="#7433FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="15.0533"
          y1="11.1367"
          x2="15.0533"
          y2="20.3751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF33C6" />
          <stop offset="1" stopColor="#7433FF" />
        </linearGradient>
      </defs>
    </svg>
  ),
  "iddera2-blue": (props) => (
    <svg
      width="94"
      height="83"
      viewBox="0 0 94 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g style={{ mixBlendMode: "multiply" }}>
        <path
          d="M44.1516 81.5751C41.0418 82.1221 38.0644 82.372 35.2139 82.366C-6.62426 82.2782 -13.6519 8.35487 27.5538 1.10672C49.8679 -2.81837 69.2609 4.36815 82.4431 12.1343C93.2932 18.5266 96.2515 32.4837 90.2043 43.5297C81.8636 58.7651 67.5206 77.4644 44.1516 81.5751Z"
          fill="#EEF9FF"
        />
      </g>
      <path
        d="M56.4059 45.2505C51.4399 50.6159 44.696 50.2974 42.1971 50.1376C41.4812 47.1401 41.0062 40.9598 45.9722 35.5933C50.9382 30.2269 58.2018 30.393 60.1842 30.7062C60.6635 32.7301 61.3719 39.884 56.4059 45.2505Z"
        fill="#34B8FC"
      />
      <g style={{ mixBlendMode: "multiply" }}>
        <path
          d="M42.1953 27.8144C50.0257 35.601 49.5197 45.8738 48.7836 49.6425C44.4163 50.8142 34.8859 50.827 27.0534 43.0382C19.2209 35.2495 19.8675 24.2981 20.4513 21.3284C23.5276 20.7084 34.365 20.0278 42.1953 27.8144Z"
          fill="#34B8FC"
        />
      </g>
      <path
        d="M52.0416 26.9854C55.1107 26.9854 57.5987 24.4974 57.5987 21.4282C57.5987 18.3591 55.1107 15.8711 52.0416 15.8711C48.9724 15.8711 46.4844 18.3591 46.4844 21.4282C46.4844 24.4974 48.9724 26.9854 52.0416 26.9854Z"
        fill="#34B8FC"
      />
      <g style={{ mixBlendMode: "multiply" }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.9138 34.6328C49.7018 40.7703 49.2894 46.9117 48.7563 49.6412C48.4402 49.726 48.097 49.8047 47.7294 49.8749C45.3735 50.301 43.3295 50.1941 42.1814 50.1207C41.4656 47.1232 40.9905 40.9429 45.9565 35.5765C46.2672 35.2407 46.587 34.9266 46.9138 34.6328Z"
          fill="#34B8FC"
        />
      </g>
    </svg>
  ),
  "iddera2-peach": (props) => (
    <svg
      width="87"
      height="89"
      viewBox="0 0 87 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g style={{ mixBlendMode: "multiply" }}>
        <path
          d="M21.6958 9.10045C24.1454 7.10812 26.6241 5.43977 29.1166 4.05671C65.7001 -16.2433 107.841 44.8971 75.3832 71.2962C57.8061 85.5921 37.3685 88.7607 22.073 88.3981C9.48347 88.0997 0.10212 77.3506 0.00380334 64.7579C-0.131801 47.3894 3.28781 24.0722 21.6958 9.10045Z"
          fill="#FFF3EA"
        />
      </g>
      <path
        d="M62.8453 53.6997C57.8793 59.0651 51.1355 58.7466 48.6365 58.5868C47.9207 55.5893 47.4456 49.409 52.4116 44.0426C57.3776 38.6761 64.6413 38.8423 66.6236 39.1554C67.1029 41.1793 67.8113 48.3332 62.8453 53.6997Z"
        fill="#FF9B9A"
      />
      <g style={{ mixBlendMode: "multiply" }}>
        <path
          d="M48.6387 36.2636C56.469 44.0502 55.9631 54.323 55.227 58.0917C50.8597 59.2634 41.3292 59.2762 33.4968 51.4874C25.6643 43.6987 26.3109 32.7474 26.8946 29.7776C29.9709 29.1576 40.8084 28.477 48.6387 36.2636Z"
          fill="#FF9B9A"
        />
      </g>
      <path
        d="M58.4849 35.4346C61.5541 35.4346 64.0421 32.9466 64.0421 29.8775C64.0421 26.8083 61.5541 24.3203 58.4849 24.3203C55.4158 24.3203 52.9277 26.8083 52.9277 29.8775C52.9277 32.9466 55.4158 35.4346 58.4849 35.4346Z"
        fill="#FF9B9A"
      />
      <g style={{ mixBlendMode: "multiply" }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M49.0044 58.6145C48.8822 58.6066 48.7592 58.5976 48.6354 58.5876C47.9202 55.5884 47.4482 49.4117 52.4116 44.048C52.7274 43.7067 53.0526 43.3878 53.385 43.0898C56.1725 49.227 55.7601 55.3677 55.227 58.0971C54.2063 58.3709 52.9036 58.5815 51.4065 58.6439C50.457 58.6805 49.6351 58.6501 49.0044 58.6145Z"
          fill="#FF9B9A"
        />
      </g>
    </svg>
  ),
  "iddera2-purple": (props) => (
    <svg
      width="91"
      height="86"
      viewBox="0 0 91 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g style={{ mixBlendMode: "multiply" }}>
        <path
          d="M78.8927 16.4528C81.1317 18.6793 83.0515 20.9688 84.6891 23.3019C108.725 57.5472 52.356 105.886 22.6892 76.3846C6.62373 60.4088 1.32299 40.4179 0.0746811 25.169C-0.952778 12.618 8.74988 2.15801 21.2623 0.735654C38.5202 -1.22614 62.0678 -0.278168 78.8927 16.4528Z"
          fill="#F5F2FF"
        />
      </g>
      <path
        d="M61.7008 54.7075C56.7348 60.0729 49.991 59.7544 47.492 59.5946C46.7762 56.5972 46.3011 50.4169 51.2671 45.0504C56.2331 39.6839 63.4967 39.8501 65.4791 40.1632C65.9584 42.1871 66.6668 49.341 61.7008 54.7075Z"
        fill="#7E5FF2"
      />
      <g style={{ mixBlendMode: "multiply" }}>
        <path
          d="M47.4903 37.2714C55.3206 45.058 54.8146 55.3308 54.0786 59.0995C49.7112 60.2712 40.1808 60.284 32.3483 52.4952C24.5159 44.7065 25.1624 33.7552 25.7462 30.7854C28.8225 30.1655 39.6599 29.4848 47.4903 37.2714Z"
          fill="#7E5FF2"
        />
      </g>
      <path
        d="M57.3531 36.4424C60.4222 36.4424 62.9103 33.9544 62.9103 30.8853C62.9103 27.8161 60.4222 25.3281 57.3531 25.3281C54.2839 25.3281 51.7959 27.8161 51.7959 30.8853C51.7959 33.9544 54.2839 36.4424 57.3531 36.4424Z"
        fill="#7E5FF2"
      />
      <g style={{ mixBlendMode: "multiply" }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.2243 44.0898C55.0124 50.2274 54.5999 56.3687 54.0668 59.0982C53.7507 59.183 53.4076 59.2618 53.04 59.3319C50.6841 59.758 48.6401 59.6511 47.492 59.5777C46.7762 56.5803 46.3011 50.4 51.2671 45.0335C51.5778 44.6977 51.8975 44.3836 52.2243 44.0898Z"
          fill="#7E5FF2"
        />
      </g>
    </svg>
  ),
  info: (props) => (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.4997 21.4193C16.2526 21.4193 20.9163 16.7556 20.9163 11.0026C20.9163 5.24964 16.2526 0.585938 10.4997 0.585938C4.74671 0.585938 0.0830078 5.24964 0.0830078 11.0026C0.0830078 16.7556 4.74671 21.4193 10.4997 21.4193Z"
        fill="currentColor"
      />
      <path
        d="M11.5413 9.95964C11.5413 9.38434 11.075 8.91797 10.4997 8.91797C9.92438 8.91797 9.45801 9.38434 9.45801 9.95964V15.168C9.45801 15.7433 9.92438 16.2096 10.4997 16.2096C11.075 16.2096 11.5413 15.7433 11.5413 15.168V9.95964Z"
        fill="white"
      />
      <path
        d="M11.5413 6.83464C11.5413 6.25934 11.075 5.79297 10.4997 5.79297C9.92438 5.79297 9.45801 6.25934 9.45801 6.83464C9.45801 7.40993 9.92438 7.8763 10.4997 7.8763C11.075 7.8763 11.5413 7.40993 11.5413 6.83464Z"
        fill="white"
      />
    </svg>
  ),
  instagram: (props) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M9.28543 7.14062C8.71711 7.14062 8.17207 7.36639 7.77021 7.76825C7.36834 8.17012 7.14258 8.71516 7.14258 9.28348C7.14258 9.8518 7.36834 10.3968 7.77021 10.7987C8.17207 11.2006 8.71711 11.4263 9.28543 11.4263C9.85376 11.4263 10.3988 11.2006 10.8007 10.7987C11.2025 10.3968 11.4283 9.8518 11.4283 9.28348C11.4283 8.71516 11.2025 8.17012 10.8007 7.76825C10.3988 7.36639 9.85376 7.14062 9.28543 7.14062ZM9.28543 5.71205C10.2326 5.71205 11.141 6.08833 11.8108 6.7581C12.4806 7.42787 12.8569 8.33628 12.8569 9.28348C12.8569 10.2307 12.4806 11.1391 11.8108 11.8089C11.141 12.4786 10.2326 12.8549 9.28543 12.8549C8.33823 12.8549 7.42983 12.4786 6.76005 11.8089C6.09028 11.1391 5.71401 10.2307 5.71401 9.28348C5.71401 8.33628 6.09028 7.42787 6.76005 6.7581C7.42983 6.08833 8.33823 5.71205 9.28543 5.71205ZM13.9283 5.53348C13.9283 5.77028 13.8342 5.99738 13.6668 6.16483C13.4993 6.33227 13.2722 6.42634 13.0354 6.42634C12.7986 6.42634 12.5715 6.33227 12.4041 6.16483C12.2366 5.99738 12.1426 5.77028 12.1426 5.53348C12.1426 5.29668 12.2366 5.06958 12.4041 4.90214C12.5715 4.73469 12.7986 4.64062 13.0354 4.64062C13.2722 4.64062 13.4993 4.73469 13.6668 4.90214C13.8342 5.06958 13.9283 5.29668 13.9283 5.53348ZM9.28543 3.5692C7.51829 3.5692 7.22972 3.5742 6.40758 3.61063C5.84758 3.63705 5.47186 3.71205 5.12329 3.84777C4.81329 3.96777 4.58972 4.11134 4.35186 4.34991C4.1283 4.56591 3.9564 4.82961 3.84901 5.12134C3.71329 5.47134 3.63829 5.84634 3.61258 6.40562C3.57544 7.1942 3.57115 7.46991 3.57115 9.28348C3.57115 11.0506 3.57615 11.3392 3.61258 12.1613C3.63901 12.7206 3.71401 13.0971 3.84901 13.4449C3.97044 13.7556 4.11329 13.9792 4.35044 14.2163C4.59115 14.4563 4.81472 14.5999 5.12186 14.7185C5.47472 14.8549 5.85044 14.9306 6.40758 14.9563C7.19615 14.9935 7.47186 14.9978 9.28543 14.9978C11.0526 14.9978 11.3411 14.9928 12.1633 14.9563C12.7219 14.9299 13.0983 14.8549 13.4469 14.7199C13.7561 14.5992 13.9811 14.4556 14.2183 14.2185C14.459 13.9778 14.6026 13.7542 14.7211 13.4471C14.8569 13.0949 14.9326 12.7185 14.9583 12.1613C14.9954 11.3728 14.9997 11.0971 14.9997 9.28348C14.9997 7.51634 14.9947 7.22777 14.9583 6.40562C14.9319 5.84705 14.8569 5.46991 14.7211 5.12134C14.6135 4.82991 14.4419 4.56631 14.219 4.34991C14.0031 4.12623 13.7394 3.95432 13.4476 3.84705C13.0976 3.71134 12.7219 3.63634 12.1633 3.61063C11.3747 3.57348 11.099 3.5692 9.28543 3.5692ZM9.28543 2.14062C11.2261 2.14062 11.4683 2.14777 12.2297 2.18348C12.9904 2.2192 13.5083 2.33848 13.964 2.51563C14.4354 2.69705 14.8326 2.94277 15.2297 3.3392C15.5929 3.69626 15.874 4.12819 16.0533 4.60491C16.2297 5.05991 16.3497 5.57848 16.3854 6.3392C16.419 7.10062 16.4283 7.34277 16.4283 9.28348C16.4283 11.2242 16.4211 11.4663 16.3854 12.2278C16.3497 12.9885 16.2297 13.5063 16.0533 13.9621C15.8745 14.439 15.5934 14.8711 15.2297 15.2278C14.8726 15.5909 14.4407 15.8719 13.964 16.0513C13.509 16.2278 12.9904 16.3478 12.2297 16.3835C11.4683 16.4171 11.2261 16.4263 9.28543 16.4263C7.34472 16.4263 7.10258 16.4192 6.34115 16.3835C5.58043 16.3478 5.06258 16.2278 4.60686 16.0513C4.12995 15.8724 3.69795 15.5913 3.34115 15.2278C2.97787 14.8708 2.69681 14.4388 2.51758 13.9621C2.34044 13.5071 2.22115 12.9885 2.18544 12.2278C2.15186 11.4663 2.14258 11.2242 2.14258 9.28348C2.14258 7.34277 2.14972 7.10062 2.18544 6.3392C2.22115 5.57777 2.34044 5.06062 2.51758 4.60491C2.69632 4.1279 2.97744 3.69585 3.34115 3.3392C3.69806 2.97579 4.13003 2.69472 4.60686 2.51563C5.06258 2.33848 5.57972 2.2192 6.34115 2.18348C7.10258 2.14991 7.34472 2.14062 9.28543 2.14062Z"
          fill="#4824C1"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="17.1429"
            height="17.1429"
            fill="white"
            transform="translate(0.714844 0.714844)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  language: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path d="M5.5 9L5 11H6L5.5 9Z" fill="#4824C1" />
      <path
        d="M18.0645 0H7.74194V3.26461H10.3226V4.57045H1.93548C0.83871 4.57045 0 5.41924 0 6.52921V13.7113C0 14.8213 0.83871 15.6701 1.93548 15.6701H2.58065V19L6.64516 15.6701H10.9677V11.0997H18.0645C19.1613 11.0997 20 10.2509 20 9.14089V1.95876C20 0.848797 19.1613 0 18.0645 0ZM6.96774 12.9931L6.64516 11.9485H4.64516L4.25806 12.9931H2.70968L4.83871 7.18213H6.3871L8.51613 12.9931H6.96774ZM16.7742 7.83505V9.14089C15.9355 9.14089 15.0323 8.87973 14.2581 8.48797C13.4839 8.87973 12.5806 9.0756 11.6774 9.14089L11.6129 7.83505C12.0645 7.83505 12.5161 7.76976 12.9677 7.63918C12.3871 7.05155 12 6.33333 11.8065 5.54983H13.1613C13.3548 6.13746 13.7419 6.5945 14.1935 6.98625C14.9032 6.39863 15.3548 5.54983 15.4194 4.57045H11.5484V3.26461H13.4839V1.95876H14.7742V3.26461H16.9032L16.9677 3.91753C17.0323 5.28866 16.5161 6.65979 15.5484 7.63918C16 7.76976 16.3871 7.83505 16.7742 7.83505Z"
        fill="#4824C1"
      />
    </svg>
  ),
  male: (props) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M30.2187 17.0069L36.8468 10.375H28.2499V6.625H43.2499V21.625H39.4999V13.0262L32.8681 19.6581C35.0315 22.4941 36.0365 26.0462 35.6794 29.5953C35.3222 33.1444 33.6298 36.4251 30.9447 38.7732C28.2596 41.1213 24.7825 42.3613 21.2175 42.2421C17.6525 42.1229 14.2661 40.6534 11.7438 38.1311C9.22158 35.6089 7.75208 32.2224 7.63286 28.6574C7.51365 25.0924 8.75363 21.6154 11.1017 18.9303C13.4498 16.2452 16.7306 14.5527 20.2796 14.1956C23.8287 13.8385 27.3808 14.8434 30.2168 17.0069H30.2187ZM21.6874 38.5C24.4225 38.5 27.0455 37.4135 28.9795 35.4795C30.9134 33.5456 31.9999 30.9225 31.9999 28.1875C31.9999 25.4525 30.9134 22.8294 28.9795 20.8955C27.0455 18.9615 24.4225 17.875 21.6874 17.875C18.9524 17.875 16.3294 18.9615 14.3954 20.8955C12.4614 22.8294 11.3749 25.4525 11.3749 28.1875C11.3749 30.9225 12.4614 33.5456 14.3954 35.4795C16.3294 37.4135 18.9524 38.5 21.6874 38.5Z" />
      </g>
    </svg>
  ),
  "mail-open": (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.0314 7.23985L12.8484 3.19688C12.5844 3.06735 12.2941 3 12 3C11.7059 3 11.4156 3.06735 11.1516 3.19688L2.9686 7.23985C2.52797 7.45363 2.15649 7.78724 1.89675 8.20243C1.637 8.61762 1.4995 9.0976 1.5 9.58735V18.2409C1.5 19.6884 2.69156 20.8659 4.15641 20.8659H19.8436C21.3084 20.8659 22.5 19.6884 22.5 18.2409V9.58735C22.5005 9.0976 22.363 8.61762 22.1033 8.20243C21.8435 7.78724 21.472 7.45363 21.0314 7.23985ZM11.8303 4.53844C11.8831 4.51254 11.9412 4.49907 12 4.49907C12.0588 4.49907 12.1169 4.51254 12.1697 4.53844L20.1094 8.46001L12.0469 12.4444C11.9941 12.4703 11.936 12.4838 11.8772 12.4838C11.8184 12.4838 11.7603 12.4703 11.7075 12.4444L3.76641 8.52235L11.8303 4.53844Z"
        fill="currentColor"
      />
    </svg>
  ),
  "mental-health": (props) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M22.625 4.75C30.2525 4.75 36.5488 10.4425 37.5013 17.8094L41.72 24.445C41.9975 24.8819 41.9412 25.5325 41.2981 25.81L37.625 27.3812V32.875C37.625 34.9469 35.9469 36.625 33.875 36.625H30.1269L30.125 42.25H13.25V35.3237C13.25 33.1112 12.4325 31.0169 10.9175 29.1269C8.85688 26.5581 7.625 23.2975 7.625 19.75C7.625 11.4662 14.3412 4.75 22.625 4.75ZM22.625 8.5C16.4113 8.5 11.375 13.5363 11.375 19.75C11.375 22.3469 12.2525 24.7994 13.8425 26.7812C15.8938 29.3388 17 32.2506 17 35.3237V38.5H26.375L26.3788 32.875H33.875V24.91L36.7812 23.665L33.8881 19.1181L33.7813 18.2894C33.0613 12.7206 28.295 8.5 22.625 8.5ZM22.625 14.125C23.66 14.125 24.5 14.965 24.5 16V17.875H26.375C27.41 17.875 28.25 18.715 28.25 19.75C28.25 20.785 27.41 21.625 26.375 21.625H24.5V23.5C24.5 24.535 23.66 25.375 22.625 25.375C21.59 25.375 20.75 24.535 20.75 23.5V21.6231L18.875 21.625C17.84 21.625 17 20.785 17 19.75C17 18.715 17.84 17.875 18.875 17.875L20.75 17.8731V16C20.75 14.965 21.59 14.125 22.625 14.125Z" />
      </g>
    </svg>
  ),
  menu: (props) => (
    <svg
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="20" height="3" rx="1.5" fill="currentColor" />
      <rect y="6" width="20" height="3" rx="1.5" fill="currentColor" />
      <rect y="12" width="20" height="3" rx="1.5" fill="currentColor" />
    </svg>
  ),
  microscope: (props) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M26.7425 5.25049L32.8362 15.8067C33.3537 16.7011 33.0462 17.8486 32.15 18.3661L29.7125 19.7724L31.5894 23.0199L28.3419 24.8949L26.4669 21.6455L24.0312 23.0536C23.135 23.5711 21.9875 23.2636 21.47 22.3674L18.0237 16.4011C14.1762 17.5674 11.375 21.1449 11.375 25.373C11.375 26.5449 11.5906 27.668 11.9825 28.703C13.4375 27.7805 15.155 27.248 17 27.248C20.1575 27.248 22.9513 28.8099 24.65 31.2024L39.065 22.8792L40.94 26.1267L26.1688 34.6561C26.3038 35.2899 26.375 35.9499 26.375 36.623C26.375 37.2661 26.3112 37.8924 26.1875 38.498H41.375V42.248L9.5 42.2499C8.3225 40.6824 7.625 38.7342 7.625 36.623C7.625 34.7349 8.18375 32.9761 9.14375 31.5042C8.17437 29.6761 7.625 27.5892 7.625 25.373C7.625 19.7574 11.1519 14.9649 16.1131 13.0917L15.3762 11.813C14.3412 10.0186 14.9544 7.72549 16.7488 6.69049L21.62 3.87799C23.4144 2.84299 25.7075 3.45611 26.7425 5.25049ZM17 30.998C13.8931 30.998 11.375 33.5161 11.375 36.623C11.375 37.2792 11.4875 37.9111 11.6938 38.498H22.3062C22.5125 37.9111 22.625 37.2792 22.625 36.623C22.625 33.5161 20.1069 30.998 17 30.998ZM23.495 7.12549L18.6238 9.93799L23.78 18.8686L28.6512 16.0561L23.495 7.12549Z" />
      </g>
    </svg>
  ),
  minus: (props) => (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 7L1 7"
        stroke="#7E5FF2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "mouse-scroll": (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M12 5L12.53 4.47C12.3894 4.32955 12.1988 4.25066 12 4.25066C11.8012 4.25066 11.6106 4.32955 11.47 4.47L12 5ZM12 13L11.47 13.53C11.6106 13.6705 11.8012 13.7493 12 13.7493C12.1988 13.7493 12.3894 13.6705 12.53 13.53L12 13ZM9.47 6.47C9.33752 6.61217 9.2654 6.80022 9.26882 6.99452C9.27225 7.18882 9.35097 7.37421 9.48838 7.51162C9.62579 7.64903 9.81118 7.72775 10.0055 7.73117C10.1998 7.7346 10.3878 7.66248 10.53 7.53L9.47 6.47ZM13.47 7.53C13.5387 7.60369 13.6215 7.66279 13.7135 7.70378C13.8055 7.74477 13.9048 7.76681 14.0055 7.76859C14.1062 7.77037 14.2062 7.75184 14.2996 7.71412C14.393 7.6764 14.4778 7.62026 14.549 7.54904C14.6203 7.47782 14.6764 7.39299 14.7141 7.2996C14.7518 7.20621 14.7704 7.10618 14.7686 7.00548C14.7668 6.90477 14.7448 6.80546 14.7038 6.71346C14.6628 6.62146 14.6037 6.53866 14.53 6.47L13.47 7.53ZM10.53 10.47C10.4613 10.3963 10.3785 10.3372 10.2865 10.2962C10.1945 10.2552 10.0952 10.2332 9.99452 10.2314C9.89382 10.2296 9.79379 10.2482 9.7004 10.2859C9.60701 10.3236 9.52218 10.3797 9.45096 10.451C9.37974 10.5222 9.3236 10.607 9.28588 10.7004C9.24816 10.7938 9.22963 10.8938 9.23141 10.9945C9.23318 11.0952 9.25523 11.1945 9.29622 11.2865C9.33721 11.3785 9.39631 11.4613 9.47 11.53L10.53 10.47ZM14.53 11.53C14.6037 11.4613 14.6628 11.3785 14.7038 11.2865C14.7448 11.1945 14.7668 11.0952 14.7686 10.9945C14.7704 10.8938 14.7518 10.7938 14.7141 10.7004C14.6764 10.607 14.6203 10.5222 14.549 10.451C14.4778 10.3797 14.393 10.3236 14.2996 10.2859C14.2062 10.2482 14.1062 10.2296 14.0055 10.2314C13.9048 10.2332 13.8055 10.2552 13.7135 10.2962C13.6215 10.3372 13.5387 10.3963 13.47 10.47L14.53 11.53ZM3.25 10V14H4.75V10H3.25ZM20.75 14V10H19.25V14H20.75ZM11.25 5V13H12.75V5H11.25ZM11.47 4.47L9.47 6.47L10.53 7.53L12.53 5.53L11.47 4.47ZM11.47 5.53L13.47 7.53L14.53 6.47L12.53 4.47L11.47 5.53ZM12.53 12.47L10.53 10.47L9.47 11.53L11.47 13.53L12.53 12.47ZM12.53 13.53L14.53 11.53L13.47 10.47L11.47 12.47L12.53 13.53ZM20.75 10C20.75 7.67936 19.8281 5.45376 18.1872 3.81282C16.5462 2.17187 14.3206 1.25 12 1.25V2.75C13.9228 2.75 15.7669 3.51384 17.1265 4.87348C18.4862 6.23311 19.25 8.07718 19.25 10H20.75ZM12 22.75C13.1491 22.75 14.2869 22.5237 15.3485 22.0839C16.4101 21.6442 17.3747 20.9997 18.1872 20.1872C18.9997 19.3747 19.6442 18.4101 20.0839 17.3485C20.5237 16.2869 20.75 15.1491 20.75 14H19.25C19.25 15.9228 18.4862 17.7669 17.1265 19.1265C15.7669 20.4862 13.9228 21.25 12 21.25V22.75ZM3.25 14C3.25 16.3206 4.17187 18.5462 5.81282 20.1872C7.45376 21.8281 9.67936 22.75 12 22.75V21.25C10.0772 21.25 8.23311 20.4862 6.87348 19.1265C5.51384 17.7669 4.75 15.9228 4.75 14H3.25ZM4.75 10C4.75 8.07718 5.51384 6.23311 6.87348 4.87348C8.23311 3.51384 10.0772 2.75 12 2.75V1.25C9.67936 1.25 7.45376 2.17187 5.81282 3.81282C4.17187 5.45376 3.25 7.67936 3.25 10H4.75Z"
        fill="currentColor"
      />
    </svg>
  ),
  playstore: (props) => (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 3.71901V28.2815C3.00016 28.3348 3.01606 28.3869 3.04569 28.4311C3.07532 28.4754 3.11737 28.51 3.16656 28.5305C3.21575 28.551 3.2699 28.5565 3.32222 28.5463C3.37453 28.5362 3.42268 28.5108 3.46062 28.4734L16.25 16.0009L3.46062 3.52713C3.42268 3.48972 3.37453 3.46434 3.32222 3.45418C3.2699 3.44402 3.21575 3.44953 3.16656 3.47003C3.11737 3.49052 3.07532 3.52508 3.04569 3.56937C3.01606 3.61366 3.00016 3.66572 3 3.71901Z"
        fill="#FDEFFF"
      />
      <path
        d="M21.6125 10.8752L5.57621 2.04019L5.56621 2.03456C5.28996 1.88456 5.02746 2.25831 5.25371 2.47581L17.8243 14.4958L21.6125 10.8752Z"
        fill="#FDEFFF"
      />
      <path
        d="M5.25444 29.5252C5.02694 29.7427 5.28944 30.1164 5.56694 29.9664L5.57694 29.9608L21.6119 21.1258L17.8238 17.5039L5.25444 29.5252Z"
        fill="#FDEFFF"
      />
      <path
        d="M28.0872 14.435L23.6091 11.9688L19.3984 15.9975L23.6091 20.0244L28.0872 17.56C29.3053 16.8869 29.3053 15.1081 28.0872 14.435Z"
        fill="#FDEFFF"
      />
    </svg>
  ),
  plus: (props) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 1L8 15"
        stroke="#7E5FF2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 8H1"
        stroke="#7E5FF2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  prescription: (props) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M37.625 4.75V8.5H33.875V14.125C36.9819 14.125 39.5 16.6431 39.5 19.75V40.375C39.5 41.41 38.66 42.25 37.625 42.25H11.375C10.34 42.25 9.5 41.41 9.5 40.375V19.75C9.5 16.6431 12.0181 14.125 15.125 14.125V8.5H11.375V4.75H37.625ZM33.875 17.875H15.125C14.09 17.875 13.25 18.715 13.25 19.75V38.5H35.75V19.75C35.75 18.715 34.91 17.875 33.875 17.875ZM26.375 21.625V25.375H30.125V29.125H26.3731L26.375 32.875H22.625L22.6231 29.125H18.875V25.375H22.625V21.625H26.375ZM30.125 8.5H18.875V14.125H30.125V8.5Z" />
      </g>
    </svg>
  ),
  stethoscope: (props) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M17 6.625V10.375H13.25V17.875C13.25 22.0188 16.6062 25.375 20.75 25.375C24.8938 25.375 28.25 22.0188 28.25 17.875V10.375H24.5V6.625H30.125C31.16 6.625 32 7.465 32 8.5V17.875C32 23.4494 27.9463 28.075 22.625 28.9694V31.9375C22.625 35.5619 25.5631 38.5 29.1875 38.5C31.9944 38.5 34.3906 36.7375 35.3281 34.2569C33.365 33.3812 32 31.4125 32 29.125C32 26.0181 34.5181 23.5 37.625 23.5C40.7319 23.5 43.25 26.0181 43.25 29.125C43.25 31.6956 41.525 33.8631 39.17 34.5344C38.0187 38.9725 33.9856 42.25 29.1875 42.25C23.4913 42.25 18.875 37.6338 18.875 31.9375V28.9694C13.5538 28.0769 9.5 23.4494 9.5 17.875V8.5C9.5 7.465 10.34 6.625 11.375 6.625H17ZM37.625 27.25C36.59 27.25 35.75 28.09 35.75 29.125C35.75 30.16 36.59 31 37.625 31C38.66 31 39.5 30.16 39.5 29.125C39.5 28.09 38.66 27.25 37.625 27.25Z" />
      </g>
    </svg>
  ),
  syringe: (props) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M43.3558 15.9605L40.5258 18.7865L36.2858 14.5465L32.0418 18.7865L39.1118 25.8585L36.2838 28.6865L34.8698 27.2725L22.1418 40.0005H10.8278L6.58581 44.2425L3.75781 41.4145L7.99981 37.1725V25.8585L20.7278 13.1305L19.3138 11.7165L22.1418 8.88853L29.2138 15.9585L33.4538 11.7165L29.2138 7.47453L32.0418 4.64453L43.3558 15.9585V15.9605ZM32.0418 24.4445L23.5558 15.9585L20.7278 18.7865L24.9698 23.0305L22.1418 25.8585L17.8998 21.6165L15.0718 24.4445L19.3118 28.6865L16.4858 31.5145L12.2418 27.2725L11.9998 27.5145V36.0005H20.4858L32.0418 24.4445Z" />
      </g>
    </svg>
  ),
  twitter: (props) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M15.9733 4.75298C15.428 4.99419 14.8497 5.1526 14.2576 5.22298C14.8817 4.84972 15.3489 4.26227 15.5719 3.57012C14.9862 3.91869 14.3441 4.16298 13.6748 4.29512C13.2252 3.81411 12.6293 3.49509 11.9797 3.38768C11.3302 3.28027 10.6633 3.39047 10.0828 3.70116C9.50234 4.01185 9.04077 4.50561 8.76986 5.10569C8.49895 5.70576 8.43388 6.37854 8.58478 7.01941C7.397 6.95987 6.23501 6.65121 5.17427 6.11345C4.11352 5.5757 3.17772 4.82087 2.42763 3.89798C2.16213 4.35401 2.0226 4.87243 2.02335 5.40012C2.02335 6.43584 2.55049 7.35084 3.35192 7.88655C2.87764 7.87162 2.4138 7.74354 1.99906 7.51298V7.55012C1.99921 8.23991 2.2379 8.90842 2.67467 9.44231C3.11144 9.9762 3.71941 10.3426 4.39549 10.4794C3.95522 10.5987 3.49357 10.6163 3.04549 10.5308C3.23611 11.1246 3.60764 11.6438 4.10806 12.0159C4.60847 12.388 5.21272 12.5943 5.8362 12.6058C5.21655 13.0925 4.50705 13.4523 3.74826 13.6645C2.98948 13.8768 2.1963 13.9374 1.41406 13.843C2.77956 14.7211 4.36913 15.1874 5.99263 15.1858C11.4876 15.1858 14.4926 10.6337 14.4926 6.68584C14.4926 6.55726 14.4891 6.42726 14.4833 6.30012C15.0682 5.87738 15.5731 5.35371 15.9741 4.75369L15.9733 4.75298Z"
          fill="#4824C1"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="17.1429"
            height="17.1429"
            fill="white"
            transform="translate(0.142578 0.714844)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  vial: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      {...props}
    >
      <path
        d="M14.0405 8.67998L14.0406 8.68001C15.3694 9.13357 16.2622 10.3816 16.2622 11.7859V18.3193H5.06328V11.7667C5.06328 10.3222 6.03665 9.02302 7.4228 8.61717C7.42287 8.61715 7.42293 8.61713 7.423 8.61711L7.51491 8.59022L8.30076 8.36036V7.54158V7.12774H13.0892V7.57373V8.35521L13.8288 8.60771L14.0405 8.67998Z"
        stroke="currentColor"
        strokeWidth="2.18516"
        fill="transparent"
      />
      <path
        d="M15.0841 6.59981H6.30664V3.53125H15.0841V6.59981Z"
        stroke="currentColor"
        strokeWidth="2"
        fill="transparent"
      />
    </svg>
  )
};

export default icons;
